import { render, staticRenderFns } from "./VisaApplicationCrewSignOff.vue?vue&type=template&id=980659aa&"
import script from "./VisaApplicationCrewSignOff.vue?vue&type=script&lang=js&"
export * from "./VisaApplicationCrewSignOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports